var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge"},[_c('img',{staticClass:"badge-img",attrs:{"src":_vm.badge().ImageUrl}}),_c('br'),_c('a',{staticClass:"badge-terms",attrs:{"target":"_blank","href":_vm.badge().TermsOfServiceUrl}},[_vm._v("\n\t\tTerms of Service\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }